var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.56 12.25C22.56 11.47 22.49 10.72 22.36 10H12V14.26H17.92C17.66 15.63 16.88 16.79 15.71 17.57V20.34H19.28C21.36 18.42 22.56 15.6 22.56 12.25Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 23.0001C14.9701 23.0001 17.4601 22.0201 19.2801 20.3401L15.7101 17.5701C14.7301 18.2301 13.4801 18.6301 12.0001 18.6301C9.14005 18.6301 6.71005 16.7001 5.84005 14.1001H2.18005V16.9401C3.99005 20.5301 7.70005 23.0001 12.0001 23.0001Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.84 14.0898C5.62 13.4298 5.49 12.7298 5.49 11.9998C5.49 11.2698 5.62 10.5698 5.84 9.90982V7.06982H2.18C1.43 8.54982 1 10.2198 1 11.9998C1 13.7798 1.43 15.4498 2.18 16.9298L5.03 14.7098L5.84 14.0898Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 5.38C13.6201 5.38 15.0601 5.94 16.2101 7.02L19.3601 3.87C17.4501 2.09 14.9701 1 12.0001 1C7.70005 1 3.99005 3.47 2.18005 7.07L5.84005 9.91C6.71005 7.31 9.14005 5.38 12.0001 5.38Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/googleLogo.65b80abd0ac33df5ca88206d1e441315.svg";
export { ForwardRef as ReactComponent };